export interface Bonus {
  label: string
  title: string
  body: string
}

export const bonuses: Bonus[] = [
  {
    label: '🎁 BONUS 1',
    title: 'WELD INSPECTION FIELD CHECKLIST PACK',
    body: 'Organize professional inspections with structured pre-weld, in-process, and final visual inspection checklists, measurement recording fields, observation tracking, follow-up controls, and documentation verification resources.',
  },
  {
    label: '🎁 BONUS 2',
    title: 'WELD DISCONTINUITY QUICK REFERENCE CARDS',
    body: 'Review common welding discontinuities with twelve technical identification cards covering appearance, typical locations, possible causes, examination methods, evidence recording, classification considerations, and inspection follow-up.',
  },
  {
    label: '🎁 BONUS 3',
    title: 'WELD MEASUREMENT & GAUGE REFERENCE GUIDE',
    body: 'Support dimensional inspections with weld gauge references, fillet leg measurement procedures, reinforcement assessment, undercut measurement, alignment checks, recording sheets, and practical measurement examples.',
  },
  {
    label: '🎁 BONUS 4',
    title: 'WELD INSPECTION REPORT & NCR TEMPLATE KIT',
    body: 'Organize quality documentation with ready-to-adapt visual inspection reports, nonconformance records, authorized repair tracking forms, reinspection reports, and daily welding inspection summaries.',
  },
  {
    label: '🎁 BONUS 5',
    title: 'WELD INSPECTION PRACTICAL CASEBOOK',
    body: 'Practice professional inspection reasoning with ten realistic welding scenarios, technical observations, measurement exercises, evidence documentation, worked solutions, and structured inspection assessment worksheets.',
  },
]
